import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'rds-loading-detail-page',
  templateUrl: './loading-detail-page.component.html',
  styleUrls: ['./loading-detail-page.component.scss']
})
export class LoadingDetailPageComponent implements OnInit {


  @Input() header: boolean = true;
  @Input() headerCols:number = 1;
  @Input() cols: number = 1;
  @Input() rows: number = 1;
  @Input() loadingType:string = 'detail';//detail, related
   
  
  
  lstRows:number[] = [];
  lstCols:number[] = [];
  constructor() { }

  ngOnInit() { 
    for (let i = 0; i < this.rows; i++) {
      this.lstRows.push(i);
    } 

    for (let i = 0; i < this.cols; i++) {
      this.lstCols.push(i);
    } 

  }

}
